import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import Button from '../shared/Button';

const useStyles = makeStyles(
  () => ({
    root: {},
    paper: {
      width: 960,
      maxWidth: 'unset',
      borderRadius: 12,
      boxShadow:
        '0 30px 66px 0 rgba(0, 0, 0, 0.09), 0 8px 58px 0 rgba(0, 0, 0, 0.05)',
      backgroundColor: color.$7,
    },
    title: {
      padding: '24px 24px 8px',
      '& > h2': {
        fontSize: 17,
        lineHeight: 1,
        color: color.$3,
      },
    },
    content: {
      fontSize: 15,
      color: color.$3,
      opacity: 0.6,
      padding: '8px 24px 12px',
    },
    actions: {
      padding: '12px 24px 24px',
    },
  }),
  {
    name: 'AlertModal',
  },
);

function AlertModal({
  isOpen,
  title,
  content,
  actions,
  onCancel,
  onClick,
  cancelText,
  submitText,
  onExited,
  isFocusCancelButton,
  isFocusSubmitButton,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      classes={{
        paper: classes.paper,
      }}
      onExited={onExited}
    >
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>{content}</DialogContent>
      <DialogActions className={classes.actions}>
        {actions || (
          <>
            <Button
              colorType="blue"
              isFocus={isFocusCancelButton}
              onClick={onCancel}
            >
              {cancelText || t('modal.not-now')}
            </Button>
            <Button
              colorType="blue"
              isFocus={isFocusSubmitButton}
              onClick={onClick}
            >
              {submitText || t('modal.submit')}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

AlertModal.defaultProps = {
  actions: null,
  cancelText: null,
  submitText: null,
  onExited: () => {},
  onCancel: () => {},
  onClick: () => {},
  isFocusCancelButton: false,
  isFocusSubmitButton: true,
};

AlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  actions: PropTypes.element,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  onExited: PropTypes.func,
  isFocusCancelButton: PropTypes.bool,
  isFocusSubmitButton: PropTypes.bool,
};

export default AlertModal;
